import { AppBar, Container, Stack } from "@mui/material";
import { Outlet } from "react-router-dom";
import OnboardingNavBar from "src/components/NavBars/OnboardingNavBar/OnboardingNavBar";

const CheckInLayout = () => {
  return (
    <Stack>
      <AppBar
        position="fixed"
        sx={{
          width: `100%`,
          boxShadow: "none",
          backgroundColor: "#ffffff",
          color: "#000000",
        }}
      >
        <Stack spacing={1}>
          <OnboardingNavBar hasNoProgressBar />
        </Stack>
      </AppBar>
      <Container
        disableGutters
        maxWidth="sm"
        sx={{
          flexGrow: 1,
          p: 2,
          mt: 12,
        }}
      >
        <Outlet />
      </Container>
    </Stack>
  );
};

export default CheckInLayout;
